import { Body, SectionHeader } from "@sprout/typography.tsx";
import Preferences from "@components/preferences.tsx";
import { useTranslation } from "react-i18next";
import React, { createContext, useContext } from "react";
import useSubscriptions from "@/queries/use_subscriptions.ts";
import "@components/job_alerts/header.scss";

export const SubscriptionCountContext = createContext<number>(0);

export const SubscriptionCountProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: subscriptions } = useSubscriptions();

  const count = subscriptions?.length || 0;

  return <SubscriptionCountContext value={count}>{children}</SubscriptionCountContext>;
};

export const JobAlertsHeader = () => {
  const count = useContext(SubscriptionCountContext);

  const { t } = useTranslation("jobAlerts");

  return (
    <div className="job-alerts-page__header">
      <SectionHeader as="h2">
        {count > 0 ? `${t("yourJobAlerts")} (${count})` : t("yourJobAlerts")}
      </SectionHeader>
      <div className="job-alerts-page__header__preferences">
        <Body>{t("preferences.emailFrequency")}</Body>
        <Preferences />
      </div>
    </div>
  );
};
